import { render, staticRenderFns } from "./StoreRentTermsEditor.vue?vue&type=template&id=4272adf8&"
import script from "./StoreRentTermsEditor.vue?vue&type=script&lang=js&"
export * from "./StoreRentTermsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports